<template>
  <el-row class="ipblacklist container_self table_parent">
    <h3>域名列表</h3>
    <el-button
      type="success"
      icon="el-icon-plus"
      size="mini"
      @click="addDomain"
      v-if="permissions.indexOf(51) != -1"
      >新增域名</el-button
    >
    <el-upload
      style="display: inline-block; margin-left: 15px"
      class="upload-demo"
      :with-credentials="true"
      action="http://adminapi.superexdrama.com/api/domains/import"
      multiple
      :limit="1"
      accept=".xlsx"
      :auto-upload="true"
      :headers="{ Authorization: token }"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :file-list="fileList"
    >
      <el-button
        size="mini"
        icon="el-icon-upload"
        type="danger"
        v-if="permissions.indexOf(51) != -1"
        >批量上传域名</el-button
      >
    </el-upload>

    <el-button
      size="mini"
      icon="el-icon-download"
      type="warning"
      style="margin-left: 15px"
      @click="downloadTemplate"
      v-if="permissions.indexOf(51) != -1"
      >下载域名模板</el-button
    >
    <el-row>
      <el-form
        :inline="true"
        :model="form"
        label-width="80px"
        class="demo-form-inline search_parent"
        style="display: flex; flex-wrap: wrap"
        size="mini"
      >
        <el-form-item label="关键字">
          <el-input
            v-model="form.keyword"
            placeholder="请输要查询的信息（关键字）"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="form.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="form.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否在线">
          <el-select v-model="form.online" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="HTTP状态">
          <el-select v-model="form.responseStatus" clearable>
            <el-option label="200" :value="200"></el-option>
            <el-option label="403" :value="403"></el-option>
            <el-option label="error" value="Err"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input
            v-model="form.customerName"
            placeholder="请输所属客户名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="客户ID">
          <el-input
            v-model="form.customerId"
            placeholder="请输所属客户ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="域名类型">
          <el-select v-model="form.dmType" placeholder="请选择域名类型" clearable>
            <el-option label="游戏类" :value="1"></el-option>
            <el-option label="资讯类" :value="2"></el-option>
            <el-option label="短剧类" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用状态">
          <el-select v-model="form.status" placeholder="请选择域名使用状态" clearable>
            <el-option label="未启用" :value="0"></el-option>
            <el-option label="已启用" :value="1"></el-option>
            <el-option label="广告单元已下线" :value="2"></el-option>
            <el-option label="广告已下线站点已下线" :value="3"></el-option>
            <el-option label="站点已彻底下线" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否自有">
          <el-select v-model="form.owner" placeholder="请选择是否是自有域名" clearable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="80px;" style="margin-left: 80px">
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button
            type="success"
            style="margin-left: 30px"
            icon="el-icon-connection"
            @click="downloadData(new Date().toISOString().slice(0, 10))"
            >导出数据</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
    <el-button
      type="danger"
      icon="el-icon-plus"
      size="mini"
      @click="batchOperation"
      v-if="permissions.indexOf(51) != -1"
      >批量更新域名状态</el-button
    >
    <el-table
      :data="domainList"
      style="width: 100%; margin-top: 10px"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      element-loading-text="查询中，请稍后"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="ID" align="center" width="100"></el-table-column>
      <el-table-column label="域名" align="center" width="160">
        <template slot-scope="scope">
          <a :href="'https://' + scope.row.dm" target="_blank">{{ scope.row.dm }}</a>
        </template>
      </el-table-column>
      <el-table-column label="所属客户" align="center" width="200">
        <template slot-scope="scope">
          <span v-if="!scope.row.customerName">--</span>
          <span v-else>{{ scope.row.customerName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="域名使用状态" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">已启用</span>
          <span v-else-if="scope.row.status == 0">未启用</span>
          <span v-else-if="scope.row.status == 2">广告单元已下线</span>
          <span v-else-if="scope.row.status == 3">广告已下线站点已下线</span>
          <span v-else>站点已彻底下线</span>
        </template>
      </el-table-column>
      <el-table-column label="HTTP状态" width="120px" align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.responseStatus"
            :class="{ 'red-text': scope.row.responseStatus != 200 }"
            >{{ scope.row.responseStatus }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="responseTime"
        label="响应时间"
        align="center"
      ></el-table-column>
      <el-table-column label="是否自有" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.owner">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="异常描述" align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.description"
            :class="{ 'red-text': scope.row.description.includes('异常') }"
            >{{ scope.row.description }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        align="center"
        width="160"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        width="160"
      ></el-table-column>
      <el-table-column label="操作" align="left" width="500" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="update(scope.row)"
            v-if="permissions.indexOf(52) != -1"
            >更新</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="deleteDomain(scope.row)"
            v-if="permissions.indexOf(53) != -1"
            >删除</el-button
          >
          <el-button type="success" size="mini" @click="consoleHistory(scope.row)"
            >操作记录</el-button
          >
          <el-button
            type="warning"
            size="mini"
            @click="makeList(scope.row)"
            v-if="permissions.indexOf(52) != -1 && scope.row.dmType === 3"
            >修改站点视频</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="refHtml(scope.row)"
            v-if="permissions.indexOf(52) != -1 && scope.row.dmType === 3"
            >更新站点内容</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="autoHtml(scope.row)"
            v-if="
              permissions.indexOf(52) != -1 && scope.row.dmType != 3
            "
            >更新站点内容</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="form.currentPage"
      :page-sizes="[20, 50, 100, 200, 400, 1000, 2000]"
      :page-size="form.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog title="批量更改域名状态" :visible="dialogFormVisible1" center>
      <div style="text-align: center">
        <el-row style="margin-bottom: 20px">
          <span style="width: 90px; display: inline-block; text-align: right"
            >域名使用状态</span
          >
          <el-select
            v-model="moreStatus"
            placeholder="请选相关设置"
            clearable
            style="margin-left: 10px"
            size="mini"
            @change="moreStatusChange"
          >
            <el-option :value="0" label="未启用"></el-option>
            <el-option :value="1" label="已启用"></el-option>
            <el-option
              :value="2"
              label="广告单元已下线"
              :disabled="disabled4"
            ></el-option>
            <el-option
              :value="3"
              label="广告已下线站点已下线"
              :disabled="disabled5"
            ></el-option>
            <el-option
              :value="4"
              label="站点已彻底下线"
              :disabled="disabled6"
            ></el-option>
          </el-select>
        </el-row>
        <el-row>
          <span style="width: 90px; display: inline-block; text-align: right"
            >所属客户</span
          >
          <el-select
            style="margin-left: 10px"
            v-model="customId"
            size="mini"
            remote
            reserve-keyword
            filterable
            placeholder="请输入关键词"
            :remote-method="searchCustom"
            @change="choseCustom"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="moreUpdate">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="string + '域名'" :visible.sync="dialogFormVisible">
      <el-form
        :model="updateDomainForm"
        class="demo-ruleForm"
        size="mini"
        :label-width="formLabelWidth"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="域名" :label-width="formLabelWidth" prop="dm">
          <el-input v-model="updateDomainForm.dm" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="域名类型" :label-width="formLabelWidth">
          <el-select v-model="updateDomainForm.dmType">
            <el-option label="游戏类" :value="1"></el-option>
            <el-option label="资讯类" :value="2"></el-option>
            <el-option label="短剧类" :value="3"></el-option>
            <el-option label="小说类" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="bucketS3名称">
                  <el-input v-model="updateDomainForm.bucketS3" autocomplete="off"></el-input>
                </el-form-item> -->
        <el-form-item label="域名使用状态" :label-width="formLabelWidth">
          <el-select
            v-model="updateDomainForm.status"
            placeholder="请选择相关设置"
            @change="statusChange"
          >
            <el-option :value="0" label="未启用"></el-option>
            <el-option :value="1" label="已启用"></el-option>
            <el-option
              :value="2"
              label="广告单元已下线"
              :disabled="disabled1"
            ></el-option>
            <el-option
              :value="3"
              label="广告已下线站点已下线"
              :disabled="disabled2"
            ></el-option>
            <el-option
              :value="4"
              label="站点已彻底下线"
              :disabled="disabled3"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input v-model="updateDomainForm.description" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否自有" :label-width="formLabelWidth">
          <!-- <el-input v-model="updateDomainForm.owner" autocomplete="off"></el-input> -->
          <el-select v-model="updateDomainForm.owner" placeholder="请选择是否自有">
            <el-option :value="0" label="否"></el-option>
            <el-option :value="1" label="是"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属客户" :label-width="formLabelWidth" prop="customerId">
          <el-select
            v-model="customId"
            remote
            reserve-keyword
            filterable
            placeholder="请输入关键词"
            :remote-method="searchCustom"
            @change="choseCustom"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          @click="updateDomainStatus('ruleForm')"
          v-if="!isAdd"
          size="mini"
          v-loading="btnLoading"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="addDomainReauest('ruleForm')"
          v-else
          size="mini"
          v-loading="btnLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogFormVisibleConsole" title="域名操作记录" width="60%">
      <el-table :data="consoleList">
        <el-table-column
          label="ID"
          prop="id"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          label="所属客户"
          width="200"
          prop="customerName"
          align="center"
        ></el-table-column>
        <el-table-column label="域名状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">已启用</span>
            <span v-else-if="scope.row.status == 0">未启用</span>
            <span v-else-if="scope.row.status == 2">广告单元已下线</span>
            <span v-else-if="scope.row.status == 3">广告已下线站点已下线</span>
            <span v-else>站点已彻底下线</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" align="center"></el-table-column>
        <el-table-column label="操作人" prop="username" align="center"></el-table-column>
        <el-table-column
          label="操作时间"
          prop="createTime"
          align="center"
          width="200"
          fixed="right"
        ></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="searchConsole.currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="searchConsole.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total1"
      >
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisibleConsole = false" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
import * as XLSX from "xlsx";
export default {
  data() {
    return {
      customId: "",
      domainList: [],
      loading: false,
      form: {
        endTime: "",
        startTime: "",
        currentPage: 1,
        customerId: "",
        customerName: "",
        online: "",
        keyword: "",
        online: "",
        pageSize: 20,
        responseStatus: "",
        description: "",
        dmType: "",
        status: "",
        owner: "",
      },
      updateDomainForm: {
        id: "",
        customerId: "",
        description: "",
        status: 0,
        dm: "",
        dmType: 1,
        owner: 1,
        bucketS3: "",
      },
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      isAdd: false,
      string: "更新",
      fileList: [],
      permissions: JSON.parse(sessionStorage.getItem("permission")),
      options: [],
      multipleSelection: [],
      dialogFormVisible1: false,
      moreStatus: "",
      disabled1: true,
      disabled2: true,
      disabled3: true,
      disabled4: true,
      disabled5: true,
      disabled6: true,
      searchConsole: {
        dm: "",
        pageSize: 20,
        currentPage: 1,
        dmId: "",
      },
      consoleList: [],
      dialogFormVisibleConsole: false,
      total1: 0,
      token: JSON.parse(sessionStorage.getItem("loginData")).token,
      isVideo: false,
      rules: {
        customerId: { required: true, message: "选择客户", trigger: "blur" },
        dm: { required: true, message: "请输入域名", trigger: "blur" },
      },
      btnLoading: false,
    };
  },
  methods: {
    handleSizeChange1(val) {
      this.searchConsole.pageSize = val;
      this.searchConsole.currentPage = 1;
      this.getConsoleList(this.searchConsole);
    },
    handleCurrentChange1(val) {
      this.currentPage = val;
      this.getConsoleList(this.searchConsole);
    },
    async getConsoleList(params, row) {
      await axiosGet("/api/domains/record_list", params).then((res) => {
        if (res.code == 0) {
          if (res.data.total) {
            this.total1 = res.data.total;
            this.consoleList = res.data.records;
            this.dialogFormVisibleConsole = true;
          } else {
            this.$message({ message: "此域名暂无操作记录", type: "warning" });
          }
        }
      });
    },
    consoleHistory(row) {
      this.searchConsole.dm = row.dm;
      this.searchConsole.dmId = row.id;
      this.searchConsole.currentPage = 1;
      this.searchConsole.pageSize = 20;
      this.getConsoleList(this.searchConsole, row);
    },
    moreStatusChange(val) {
      if (val) {
        if (val === 1) {
          this.disabled4 = false;
          this.disabled5 = true;
          this.disabled6 = true;
        } else if (val === 2) {
          this.disabled5 = false; // 广告单元已下线被选中，广告已下线站点已下线可选
          this.disabled4 = true;
          this.disabled6 = true;
        } else if (val === 3) {
          this.disabled6 = false; // 广告已下线站点已下线被选中，站点已彻底下线可选
          this.disabled5 = true;
          this.disabled4 = false;
        } else if (val === 4) {
          this.disabled4 = false;
          this.disabled5 = false;
          this.disabled6 = false;
        }
      } else {
        this.disabled4 = true;
        this.disabled5 = true;
        this.disabled6 = true;
      }
    },
    statusChange(val) {
      if (val) {
        if (val === 1) {
          this.disabled1 = false;
          this.disabled2 = true;
          this.disabled3 = true;
        } else if (val === 2) {
          this.disabled2 = false; // 广告单元已下线被选中，广告已下线站点已下线可选
          this.disabled4 = true;
          this.disabled3 = true;
        } else if (val === 3) {
          this.disabled3 = false; // 广告已下线站点已下线被选中，站点已彻底下线可选
          this.disabled2 = true;
          this.disabled1 = false;
        } else if (val === 4) {
          this.disabled1 = false;
          this.disabled2 = false;
          this.disabled3 = false;
        }
      } else {
        this.disabled1 = true;
        this.disabled2 = true;
        this.disabled3 = true;
      }
    },
    searchCustom(keyword) {
      if (keyword) {
        this.getCustomList({ currentPage: 1, pageSize: 20, keyword: keyword });
      }
    },
    moreUpdate() {
      let ids = [];
      let lists = this.multipleSelection;
      for (var i = 0; i < lists.length; i++) {
        ids.push(lists[i].id);
      }
      if (this.moreStatus) {
        axiosPost(
          "/api/domains/update_status",
          { ids: ids, status: this.moreStatus, customerId: this.customId },
          "JSON"
        ).then((res) => {
          if (res.code == 0) {
            this.$message({ message: "域名状态批量操作成功", type: "success" });
            this.multipleSelection = [];
            this.getList(this.form);
            this.dialogFormVisible1 = false;
          } else {
            this.dialogFormVisible1 = false;
          }
        });
      } else {
        this.$message({ message: "请选择更改的状态", type: "error" });
      }
    },
    getCustomList(params) {
      axiosGet(
        "/api/customer/list?currentPage=" +
          params.currentPage +
          "&pageSize=" +
          params.pageSize +
          "&keyword=" +
          params.keyword
      ).then((res) => {
        if (res.code == 0) {
          this.options = res.data.records;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    choseCustom(val) {
      this.updateDomainForm.customerId = val;
    },
    addDomain() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields(); // 重置表单验证
      }
      this.options = "";
      this.customId = "";
      this.isAdd = true;
      this.string = "添加";
      this.updateDomainForm = {
        customerId: "",
        description: "",
        status: 0,
        dm: "",
        dmType: 1,
        owner: 1,
        bucketS3: "",
      };
      this.dialogFormVisible = true;
    },
    batchOperation() {
      let lists = this.multipleSelection;
      let firstStatus = lists[0].status;
      let firstCustom = lists[0].customerId;
      this.customId = "";
      this.options = []; //客户列表
      if (firstCustom) {
        axiosGet("/api/customer/info", { id: firstCustom }).then((res) => {
          if (res.code == 0) {
            this.customId = res.data.id;
            this.options = [res.data];
          }
        });
      }

      this.moreStatus = firstStatus;
      if (firstStatus) {
        if (firstStatus === 1) {
          this.disabled4 = false;
          this.disabled5 = true;
          this.disabled6 = true;
        } else if (firstStatus === 2) {
          this.disabled5 = false; // 广告单元已下线被选中，广告已下线站点已下线可选
          this.disabled4 = true;
          this.disabled6 = true;
        } else if (firstStatus === 3) {
          this.disabled6 = false; // 广告已下线站点已下线被选中，站点已彻底下线可选
          this.disabled5 = true;
          this.disabled4 = false;
        } else if (firstStatus === 4) {
          this.disabled4 = false;
          this.disabled5 = false;
          this.disabled6 = false;
        }
      } else {
        this.disabled4 = true;
        this.disabled5 = true;
        this.disabled6 = true;
      }

      if (
        lists.some((element) => element.status !== firstStatus) ||
        lists.some((element) => element.customerId !== firstCustom)
      ) {
        this.$message({ message: "域名所属客户不一致，请仔细筛选", type: "error" });
        return false;
      }
      if (!lists.length) {
        this.$message({ message: "请最少选择一个域名", type: "error" });
        return false;
      } else {
        this.dialogFormVisible1 = true;
      }
    },
    downloadTemplate() {
      const data = [
        [
          "域名",
          "类型（1游戏，2资讯，3短剧）",
          "状态（0启用，1禁用",
          "是否自有（0否，1是）",
          "此行为表头，请勿删除",
        ],
        ["abc.com", "2", "0", "0", "此行为示例，请勿上传"],
      ];
      const ws = XLSX.utils.aoa_to_sheet(data);
      ws["!cols"] = [{ wch: 36 }, { wch: 36 }, { wch: 36 }, { wch: 36 }, { wch: 36 }];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "domaintemplate.xlsx");
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(link);
    },
    downloadData(fileName) {
      var content = [];
      if (!this.domainList.length) {
        this.$message({ message: "数据为空", type: "error" });
        return fase;
      }
      // const content=this.domainList;
      for (var c = 0; c < this.domainList.length; c++) {
        content.push([this.domainList[c].dm, this.domainList[c].description]);
      }
      const blob = new Blob([content]);
      const ws = XLSX.utils.aoa_to_sheet(content);
      // 设置第一列宽度为 20
      ws["!cols"] = [{ wch: 36 }, {}]; // 第一列宽度为 20，第二列宽度自动调整
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      XLSX.writeFile(wb, fileName + ".xlsx");
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.$message({ message: "域名批量上传成功", type: "success" });
        this.getList(this.form);
      } else {
        this.$message({ message: res.msg, type: "error" });
      }
    },
    async addDomainReauest(formName) {
      this.btnLoading = true;
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
      if (!valid) {
        this.btnLoading = false;
        return false;
      }
      if (this.updateDomainForm.dm) {
        this.updateDomainForm.bucketS3 = this.updateDomainForm.dm;
      }
      await axiosPost("/api/domains/add", this.updateDomainForm, "JSON").then((res) => {
        if (res.code == 0) {
          this.dialogFormVisible = false;

          this.getList(this.form);
          this.isAdd = false;
          if (this.updateDomainForm.dmType == 3) {
            axiosPost(
              "/api/movie/add_domain",
              { domain: this.updateDomainForm.dm, movieId: "all" },
              "JSON"
            ).then((res) => {
              if (res.code == 0) {
                this.$message({ message: "域名配置成功", type: "success" });
              }
            });
          } else {
            this.$message({ message: "域名新增成功", type: "success" });
          }
        }
      });
      this.btnLoading = false;
    },
    getList(params) {
      this.loading = true;
      axiosGet("/api/domains/list", params).then((res) => {
        if (res.code == 0) {
          this.domainList = res.data.records;
          this.loading = false;
          this.total = res.data.total;
        } else {
          this.loading = false;
        }
      });
    },
    onSubmit() {
      this.form.currentPage = 1;
      this.form.pageSize = 20;
      this.getList(this.form);
    },
    deleteDomain(row) {
      this.$confirm("确定要删除 " + row.dm + " 这个域名吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          axiosPost("/api/domains/delete", { id: row.id }, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: "域名删除成功", type: "success" });
              this.getList(this.form);
            }
          });
        })
        .catch(() => {});
    },
    update(row) {
      this.string = "更新";
      row.status = parseInt(row.status);
      this.options = [];
      this.customId = "";
      this.updateDomainForm = {
        id: row.id,
        customerId: row.customerId,
        description: row.description,
        status: row.status,
        dm: row.dm,
        dmType: row.dmType,
        owner: row.owner,
        bucketS3: row.bucketS3,
      };
      if (row.status) {
        if (row.status === 1) {
          this.disabled1 = false;
          this.disabled2 = true;
          this.disabled3 = true;
        } else if (row.status === 2) {
          this.disabled2 = false; // 广告单元已下线被选中，广告已下线站点已下线可选
          this.disabled1 = true;
          this.disabled3 = true;
        } else if (row.status === 3) {
          this.disabled3 = false; // 广告已下线站点已下线被选中，站点已彻底下线可选
          this.disabled1 = true;
          this.disabled2 = true;
        } else if (row.status === 4) {
          this.disabled1 = false;
          this.disabled2 = false;
          this.disabled3 = false;
        }
      } else {
        this.disabled1 = true;
        this.disabled2 = true;
        this.disabled3 = true;
      }
      this.dialogFormVisible = true;
      this.options = []; //客户列表
      if (!row.customerId) {
        return false;
      }
      axiosGet("/api/customer/info", { id: row.customerId }).then((res) => {
        if (res.code == 0) {
          this.customId = res.data.id;
          this.options = [res.data];
        }
      });
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getList(this.form);
    },
    handleCurrentChange(val) {
      this.form.currentPage = val;
      this.getList(this.form);
    },
    async updateDomainStatus(formName) {
      this.btnLoading = true;
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
      if (!valid) {
        this.btnLoading = false;
        return false;
      }
      if (this.updateDomainForm.dm) {
        this.updateDomainForm.bucketS3 = this.updateDomainForm.dm;
      }
      if (this.updateDomainForm.dm) {
        this.updateDomainForm.bucketS3 = this.updateDomainForm.dm;
      }
      await axiosPost("/api/domains/update", this.updateDomainForm, "JSON").then(
        (res) => {
          if (res.code == 0) {
            this.$message({ message: "域名更新成功", type: "success" });
            this.dialogFormVisible = false;
            this.getList(this.form);
          }
        }
      );
      this.btnLoading = false;
    },
    makeList(row) {
      if (row.dm) {
        // console.log(row.dm);
        sessionStorage.setItem("needDm", row.dm);
        this.$router.push("/videoList");
      }
    },
    refHtml(row) {
      axiosGet("/api/domains/refresh_sv_template", { domain: row.dm }).then((res) => {
        if (res.code == 0) {
          this.$message({ message: "站点内容已更新", type: "success" });
        }
      });
    },
    autoHtml(row) {
      axiosPost("/api/cms/article/make/all", { domain: row.dm }, "JSON").then((res) => {
        if (res.code == 0) {
          this.$message({ message: "站点内容已更新", type: "success" });
        }
      });
    },
  },
  mounted() {
    this.getList(this.form);
  },
};
</script>
<style>
.red-text {
  color: red;
}
.el-table th.el-table__cell {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/view/domainManager/index.vue